import React, { useState, useEffect } from 'react'
import { Spin, Pagination, message } from 'antd'
import { Link } from 'react-router-dom'
import UseDebounce from '../../helpers/UseDebounce'
import { getListProductionStage } from '../../../services/api/ProductionStageService'
import ProductionStageFilters from './Filters/ProductionStageFilters'
import ProductionStageTable from './ProductionStageTable'
import { stringify } from 'qs'
import { getListPartner } from '../../../services/api/3dApi'

function ProductionStagePage() {
    const [listData, setListData] = useState([])
    const [listPartner, setListPartner] = useState([])
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [stage, setStage] = useState('')
    const [partner, setPartner] = useState('')
    const [status, setStatus] = useState('')
    const [updatedStart, setUpdatedStart] = useState('')
    const [updatedEnd, setUpdatedEnd] = useState('')
    const [limit, setLimit] = useState(20)
    const [total, setTotal] = useState(0)
    const [error, setError] = useState('')

    const debounceStage = UseDebounce(stage, 1000)

    const getPartner = async () => {
        const payload = {
            page: 1,
            limit: 10000,
            hidden: false,
        }
        try {
            const { data, success } = await getListPartner(payload)
            const { partners } = data
            if (!success) return
            setListPartner(partners)
        } catch (e) {
        }
    }

    const fetchData = async () => {
        setLoading(true)
        setError('')
        const payload = {
            page,
            limit,
        }
        const query = {}
        if (stage) query.stage_name = stage
        if (partner) query.partner = partner
        if (status) query.status = status
        if (updatedStart && updatedEnd) query.updated = {
            from: updatedStart,
            to: updatedEnd,
        }
        if (Object.keys(query).length > 0) payload.query = query

        const QueryData = stringify(payload, { encode: false })

        try {
            const { data: res } = await getListProductionStage(QueryData)
            const { data, success, message: mess } = { ...res }
            if (!success) {
                throw new Error(mess)
            }
            const { total, stages } = data
            setListData(stages)
            setTotal(total)
        } catch (error) {
            setError(error.message || 'Unknown error.')
            message(error.message || 'Unknown error.')
        } finally {
            setLoading(false)
        }

    }


    const handlePageChange = (page, pageSize) => {
        setLimit(pageSize)
        setPage(pageSize !== limit ? 1 : page)
    }

    const handleChangeStage = (value) => {
        setStage(value)
        setPage(1)
    }

    const handleChangeStatus = (value) => {
        setStatus(value)
        setPage(1)
    }

    const handleChangeSelect = (value) => {
        setPartner(value)
        setPage(1)
    }

    const handleChangeUpdated = (momentArray, dateStringArray) => {
        setUpdatedStart(dateStringArray[0])
        setUpdatedEnd(dateStringArray[1])
        setPage(1)
    }

    useEffect(() => {
        fetchData()
    }, [debounceStage, status, updatedStart, updatedEnd, limit, page, partner])
    useEffect(() => {
        getPartner()
    }, [])


    return (
        <div className='ProductionStagePage'>
            <div className='PageHeading d-flex align-items-center justify-content-between border-bottom'>
                <h1 className="PageTitle font-weight-bold mb-0">Quản lý công đoạn sản xuất</h1>
                <div className="RightTop">
                    <Link to={`/production-stage/create`} className='btn btn-primary mb-2' style={{ background: '#477BF6' }}>
                        Thêm mới
                    </Link>
                </div>
            </div>
            <div className="SectionInner mt-3 card px-3 py-3">
                <div className="filter align-items-center mt-2">
                    <ProductionStageFilters
                        stage={stage}
                        status={status}
                        partner={partner}
                        updatedStart={updatedStart}
                        updatedEnd={updatedEnd}
                        loading={loading}
                        listPartner={listPartner}
                        handleChangeStatus={handleChangeStatus}
                        handleChangeStage={handleChangeStage}
                        handleChangeUpdated={handleChangeUpdated}
                        handleChangeSelect={handleChangeSelect}
                    />
                </div>
                <div className='Error'>
                    {error &&
                        <span className='text-danger font-weight-bold'>{error}</span>
                    }
                </div>
                <div className='Total d-flex justify-content-end'>
                    {total > 0 &&
                        <div><span>{total}</span> items</div>
                    }
                </div>
                <Spin spinning={loading} tip='Data Loading...'>
                    <ProductionStageTable
                        listData={listData}
                        loading={loading}
                        reload={fetchData}
                    />
                    <Pagination
                        pageSizeOptions={['10', '20', '50', '100']}
                        onChange={handlePageChange}
                        className='text-right'
                        pageSize={limit}
                        showSizeChanger
                        current={page}
                        total={total}
                    />
                </Spin>
            </div>
        </div>
    )
}

export default ProductionStagePage